import React from 'react'
import MaterialSymbol from '../material-symbol'

const NotificationsActive = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="notifications_active" {...props} />
))

NotificationsActive.displayName = 'NotificationsActive'

export default NotificationsActive
